module.exports = __webpack_public_path__ + "static/media/qr-code.eeb27c03.jpg";